import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import IconArrow from "../../../../assets/IconArrow";
import TransactionTitle from "./transactionTitle";
const BlockContentDriver = ({ title, borderSection, contentBlock, orderNumber, dropdown, dropdownSibling, modifierClass, hidden }) => {
    const [isContentVisible, setIsContentVisible] = useState(true);
    const toggleContentVisibility = () => {
        setIsContentVisible(!isContentVisible);
        const siblingElements = document.querySelectorAll('.transaction__block--sibling');
        siblingElements.forEach((element) => {
            if (isContentVisible) {
                element.style.display = 'none';
            }
            else {
                element.removeAttribute('style');
            }
        });
    };
    // if orderNumber is noy null or undefined, then scroll to the top of the page in <768px
    if (orderNumber != null && orderNumber !== undefined && orderNumber !== "") {
        const width = window.innerWidth;
        if (width < 768) {
            window.scrollTo(0, 0);
        }
    }
    const border = borderSection !== undefined ? `transaction__block--${borderSection}` : "";
    const isDropdown = dropdown ? "transaction__block--dropdown" : "";
    const sibling = dropdownSibling ? "transaction__block--sibling" : "";
    const isActive = !isContentVisible ? "transaction__block-icon-dropdown--active" : "";
    const customClassBlock = modifierClass ? `transaction__block--${modifierClass}` : "";
    return (_jsxs("div", { className: `transaction__block ${border} ${isDropdown} ${sibling} ${customClassBlock}`, children: [!hidden &&
                _jsx(_Fragment, { children: _jsxs("div", { className: "transaction__block-title", children: [_jsx(TransactionTitle, { title: title }), orderNumber && _jsx("span", { className: "transaction__block-order", children: orderNumber }), dropdown && (_jsx("span", { className: `transaction__block-icon-dropdown ${isActive}`, onClick: toggleContentVisibility, children: _jsx(IconArrow, {}) }))] }) }), isContentVisible && contentBlock && (_jsx("div", { className: "transaction__content", children: contentBlock }))] }));
};
export default BlockContentDriver;
